import { motion } from 'framer-motion';
import './Header.css';

const Header = () => {
  return (
    <motion.header
      className="header"
      initial={{ opacity: 0, y: -20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6, ease: 'easeOut' }}
    >
      <div className="header__container">
        <div className="header__brand">
          <h1 className="header__logo">Rib-n-Dip</h1>
          <p className="header__slogan">No Rib Left Dry</p>
        </div>
        <div className="header__shimmer"></div>
      </div>
    </motion.header>
  );
};

export default Header;
